import { useAuthUser } from "../../auth/hooks/useAuthUser";

export function useCanBuyExtraCoins () {
  const { user } = useAuthUser();
  // return false;
  return user?.candefi_membership?.plan?.can_buy_extra_coins || false;
}